import request from '@/units/request';

export default {
  //省市区列表
  area: () =>
    request({
      url: 'data.area/index',
      method: 'GET',
    }),
  //常见问题
  faq: () =>
    request({
      url: 'data.faq/index',
      method: 'GET',
    }),
  //富文本
  richtext: (params) =>
    request({
      url: 'data.richtext/index',
      method: 'GET',
      params
    }),
    //富文本
  richtextList: (params) =>
    request({
      url: 'data.richtext/list',
      method: 'GET',
      params
    }),
};
